import axios from 'axios'

export default({
    state: {
        titles: [],
    },

    getters: {
        getTitles(state){ return state.titles },
    },

    mutations: {
        setTitles(state, value){ state.titles = value },
    },

    actions: {
        getTitles({ commit }){
            commit('setLoading')
            return new Promise((resolve) => {
                axios.get('/titles')
                .then((response) =>{
                    commit('setTitles', response.data)
                    resolve()
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },
    },
});
